import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import Upgrade401kModal from "../components/Upgrade401kModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar, faChartSimple, faGear, faBullseye, faSave, faInfoCircle, faExclamationTriangle, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import Select from "react-select";
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';
import { toast } from 'react-hot-toast';

function Contribution() {
  const { user } = useUser();
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [crypto, setCrypto] = useState([]);
  useEffect(() => {
    fetch(`/coin_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    var coinList = data.data;
    const updatedData = coinList.map((coin, index) => ({
        id: index + 1,
        logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
        name: coin.name,
        type: 'crypto',
        symbol: coin.symbol,
        price: Number(coin.quote.USD.price.toFixed(2)),
        amount: 0,
    }));
    setCrypto(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
      minWidth: "135px"
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  const frequencyoptions = [
    {
        value: 'bi-weekly',
        label: 'Bi-weekly'
    },
    {
        value: 'monthly',
        label: 'Monthly'
    },
    {
        value: 'semi-monthly',
        label: 'Semi-monthly'
    },
  ]
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [enrollment, setEnrollment] = useState([]);
  const [allSavings, setAllSavings] = useState([]);
  const [savingshistory, setSavingsHistory] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
    credentials: "include",
    method: "POST",
    headers: {
        "Content-Type": "application/json"
    },
    body: JSON.stringify({ fetchsavings: true })
    })
    .then(response => response.json())
    .then(data => {
        if (data.status === "success") {
          const updatedSavings = data.savings.map(tx => {
            const coinName = tx.method.split(" - ")[0];
            let logo = null;
            let symbol = null;
            let amountUSD = null;
            const asset = crypto.find(asset => asset.name === coinName);
            if (asset) {
                logo = asset.logo;
                symbol = asset.symbol;
                amountUSD = asset.price * tx.amount;
            }
            return {
                ...tx,
                logo,
                symbol,
                amountUSD
            };
          });
          const updatedSavings1 = data.all.map(tx => {
            const coinName = tx.method.split(" - ")[0];
            let logo = null;
            let symbol = null;
            let amountUSD = null;
            const asset = crypto.find(asset => asset.name === coinName);
            if (asset) {
              logo = asset.logo;
              symbol = asset.symbol;
              amountUSD = asset.price * tx.amount;
            }
            return {
              ...tx,
              logo,
              symbol,
              amountUSD
            };
          });
          setAllSavings(updatedSavings1);
          setSavingsHistory(updatedSavings);
        }
    })
    .catch(err => {
    })
  }, [user, crypto]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ fetchEnrollment: true })
    })
    .then(response => response.json())
    .then(data => {
        if (data.status === "success") {
          setEnrollment(data.enrollment)
        }
    })
    .catch(err => {
    })
  }, [user, crypto]);
  const currentYear = new Date().getFullYear();
  const employeeMatches = allSavings.filter((item) => {
    const itemYear = new Date(item.date).getFullYear();
    return (
        item.type === "employee match" &&
        item.status === "success" &&
        itemYear === currentYear
    );
  });
  const totalYTDMatch = employeeMatches.reduce((sum, item) => sum + parseFloat(item.amountUSD || 0),0);
  const [contribution_rate, setContribution_rate] = useState(0);
  const [cRate, setCRate] = useState(Number(user?.savings_rate));
  const [frequency, setFrequency] = useState(user?.frequency);
  useEffect(() => {
    let rate = 1;
    if(frequency == "monthly"){
        rate = 1;
    }else if(frequency == "bi-weekly" || frequency == "semi-monthly"){
        rate = 0.5;
    }
    setContribution_rate(rate);
  }, [user, frequency])
  const SaveRate = () =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/retirement.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ saverate: true, rate: cRate, frequency: frequency})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
      }else{
        toast.error(data.message);
      }
      setLoading(false);
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  }
  useEffect(() => {
    if(frequency && cRate){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [frequency, cRate]);

  if (!enrollment || typeof enrollment !== 'object' || Object.keys(enrollment).length === 0) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Upgrade401kModal UserDetails={user} enrollment={enrollment} />
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Contributions" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar"> 
          <Header title="Contributions" icon={<FontAwesomeIcon icon={faChartSimple} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main className="container mb-5">
            <h2 className="mt-3 mb-0" style={{fontWeight:'900'}}>Contributions</h2>
            <p className="mb-0" style={{fontSize: '14px'}}>Manage your 401k contribution settings and view payroll history</p>
            <div className="row">
                <div className="col-lg-8 g-4">
                    <div className="mycard p-3" style={{border:'1px solid #a9a9a90f'}}>
                        <div className="d-flex align-items-center">
                            <FontAwesomeIcon icon={faGear} className="text-info" style={{fontSize: '18px'}} />
                            <h5 className="mb-0 ms-2" style={{fontWeight:'900'}}>Contribution Settings</h5>
                        </div>
                        <div className="row">
                            <div className="col-lg-6 g-4">
                                <label className="fw-semibold mb-1 mt-2">Contribution Rate (%)</label>
                                <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                                    <input 
                                    type="number"
                                    placeholder="0.00000000"
                                    className="inputNone"
                                    value={cRate}
                                    onChange={(e) => setCRate(e.target.value)}
                                    />
                                </div>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>Maximum: 27.1%</p>
                                <label className="fw-semibold mb-1 mt-4">Contribution Frequency</label>
                                <Select
                                    options={frequencyoptions}
                                    value={frequencyoptions.find((opt) => opt.value === frequency)}
                                    onChange={(selected) => {
                                        setFrequency(selected.value);
                                    }}
                                    isSearchable
                                    styles={darkThemeStyles}
                                    className="w-full"
                                />
                            </div>
                            <div className="col-lg-6 g-4">
                                <div className="p-3 rounded-3" style={{backgroundColor: '#ff6b3507'}}>
                                    <p className="mb-3 text-prime fw-semibold">Contribution Preview</p>
                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                        <p className="mb-0" style={{fontSize:'14px', color:'#ff6b3582'}}>Contribution Preview</p>
                                        <p className="mb-0 fw-semibold text-prime" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency((contribution_rate * Number(enrollment?.monthly_salary)) * (cRate / 100))}</p>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="mb-0" style={{fontSize:'14px', color:'#ff6b3582'}}>Monthly:</p>
                                        <p className="mb-0 fw-semibold text-prime" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(Number(enrollment?.monthly_salary) * (cRate / 100))}</p>
                                    </div>
                                    <hr className="bg-prime" />
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="mb-0" style={{fontSize:'14px', color:'#ff6b3582'}}>Annual:</p>
                                        <p className="mb-0 fw-semibold text-prime" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency((Number(enrollment?.monthly_salary) * (cRate / 100)) * 12)}</p>
                                    </div>
                                </div>
                                <div className="p-3 rounded-3 mt-3" style={{backgroundColor: '#ff6b3507'}}>
                                    <p className="mb-3 text-prime fw-semibold">Employer Match</p>
                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                        <p className="mb-0" style={{fontSize:'14px', color:'#ff6b3582'}}>Match rate:</p>
                                        <p className="mb-0 fw-semibold text-prime" style={{fontSize:'14px'}}>6.0%</p>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="mb-0" style={{fontSize:'14px', color:'#ff6b3582'}}>Annual match:</p>
                                        <p className="mb-0 fw-semibold text-prime" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(((enrollment?.monthly_salary * (cRate/100)) * (6/100)) * 12)}</p>
                                    </div>
                                </div>
                                <div className="mt-3 d-flex align-items-center justify-content-end">
                                    <div className={`myBtn px-3 py-2 rounded-2 fw-semibold ${disable === true ? "disabled" : null}`} onClick={disable === true ? null : SaveRate} style={{fontSize:'14px'}}>{loading?(<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />) : (<><FontAwesomeIcon icon={faSave} className="me-2" style={{ fontSize: '16px' }} />Save Changes</>)}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 g-4">
                    <div className="mycard p-3" style={{border:'1px solid #a9a9a90f'}}>
                        <div className="d-flex align-items-center">
                            <FontAwesomeIcon icon={faBullseye} className="text-info" style={{fontSize: '18px'}} />
                            <h5 className="mb-0 ms-2" style={{fontWeight:'900'}}>Employer Match</h5>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mt-4 mb-2">
                            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Match Utilization</p>
                            <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{((Number(totalYTDMatch)/(((enrollment?.monthly_salary * (Number(user?.savings_rate)/100)) * (6/100)) * 12)) * 100) > 100 ? 100 : formatCurrency(((Number(totalYTDMatch)/(((enrollment?.monthly_salary * (Number(user?.savings_rate)/100)) * (6/100)) * 12)) * 100))}%</p>
                        </div>
                        <div className="rounded-pill w-100" style={{height:'10px',backgroundColor:'#0dcaf012'}}>
                            <div className="rounded-pill h-100 bg-info" style={{width:((Number(totalYTDMatch)/(((enrollment?.monthly_salary * (Number(user?.savings_rate)/100)) * (6/100)) * 12)) * 100) > 100 ? 100 : formatCurrency(((Number(totalYTDMatch)/(((enrollment?.monthly_salary * (Number(user?.savings_rate)/100)) * (6/100)) * 12)) * 100))+'%'}}></div>
                        </div>
                        <div className="d-flex align-items-center justify-content-around my-4">
                            <div className="text-center">
                                <h3 className="mb-0 text-success" style={{fontWeight:'900'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(totalYTDMatch * rate)}</h3>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>Current YTD Match</p>
                            </div>
                            <div className="text-center">
                                <h3 className="mb-0" style={{fontWeight:'900'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(((enrollment?.monthly_salary * (Number(user?.savings_rate)/100)) * (6/100)) * 12)}</h3>
                                <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>Maximum Annual Match</p>
                            </div>
                        </div>
                        <div className="p-3 rounded-3" style={{backgroundColor: '#0dcaf012'}}>
                            <p className="mb-1 text-info fw-semibold"><FontAwesomeIcon icon={faInfoCircle} className="text-info me-1" style={{fontSize: '16px'}} /> Match Details</p>
                            <ul className="text-inf mb-0" style={{fontSize:'14px'}}>
                                <li>Company matches 6.0% of your salary</li>
                                <li>Maximum annual match: {getCurrencySymbol(user?.currency)}{formatCurrency(((enrollment?.monthly_salary * (Number(user?.savings_rate)/100)) * (6/100)) * 12)}</li>
                                <li>Vesting: 75.0% after 3 years</li>
                            </ul>
                        </div>
                        <div className="p-3 rounded-3 mt-3" style={{backgroundColor: '#ff6b3507'}}>
                            <p className="mb-1 text-prime fw-semibold"><FontAwesomeIcon icon={faBullseye} className="text-prime me-1" style={{fontSize: '16px'}} /> Match Details</p>
                            <p className="ms-4 mb-0" style={{fontSize:'14px',color:'#ff6b3582'}}>Great job! You're maximizing your employer match.</p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-8 g-4">
                    <div className="mycard p-3" style={{border:'1px solid #a9a9a90f'}}>
                        <div className="d-flex align-items-center mb-4">
                            <FontAwesomeIcon icon={faCalendar} className="text-success" style={{fontSize: '18px'}} />
                            <h5 className="mb-0 ms-2" style={{fontWeight:'900'}}>Payroll History</h5>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-dark align-middle">
                                <thead>
                                    <tr className="fs-7">
                                        <th className="fw-normal text-light" style={{width: '150px'}}>Pay Date</th>
                                        <th className="fw-normal text-light">Gross Pay</th>
                                        <th className="fw-normal text-light">Your Contribution</th>
                                        <th className="fw-normal text-light">Employer Match</th>
                                        <th className="fw-normal text-light">Total</th>
                                    </tr>
                                </thead>
                                <tbody style={{fontSize: '14px'}}>
                                    {savingshistory.length > 0 ? (
                                        savingshistory.map((history, index) => (
                                            <tr key={index}>
                                                <td>{history.date}</td>
                                                <td>{getCurrencySymbol(user?.currency)}{formatCurrency((Number(history.amountUSD) / (Number(user?.savings_rate)/100)) * rate)}</td>
                                                <td className="text-prime">{getCurrencySymbol(user?.currency)}{formatCurrency(Number(history.amountUSD) * rate)}</td>
                                                <td className="text-success">{getCurrencySymbol(user?.currency)}{formatCurrency((Number(history.amountUSD)*(6/100))*rate)}</td>
                                                <td>{getCurrencySymbol(user?.currency)}{formatCurrency(((Number(history.amountUSD) * (6/100)) + Number(history.amountUSD)) * rate)}</td>
                                            </tr>
                                        ))
                                        ) : (
                                        <tr>
                                            <td className="text-center" colSpan={5}>You have not made any activity yet.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 g-4">
                    <div className="mycard p-3" style={{border:'1px solid #a9a9a90f'}}>
                        <div className="d-flex align-items-center">
                            <FontAwesomeIcon icon={faExclamationTriangle} className="text-prime" style={{fontSize: '18px'}} />
                            <h5 className="mb-0 ms-2" style={{fontWeight:'900'}}>Risk Assessment</h5>
                        </div>
                        <div className="rounded-3 p-3 mt-4" style={{backgroundColor:'#ff6b3509',border:'1px solid #ff6b35'}}>
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="mb-0 fw-semibold" style={{fontSize:'16px'}}>Current Portfolio</p>
                                <p className="mb-0 text-uppercase text-warning" style={{fontWeight:'900'}}>MODERATE RISK</p>
                            </div>
                            <p className="mb-0 mt-2" style={{fontSize:'14px'}}>Balanced growth with moderate volatility</p>
                        </div>
                        <p className="mb-0 mt-4 fw-semibold">Risk Tolerance Preference</p>
                        <div className="d-flex align-items-center justify-content-between">
                            <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>Conservative</p>
                            <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>Moderate</p>
                            <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>Aggressive</p>
                        </div>
                        <p className="text-center mb-4 mt-3" style={{fontSize:'14px'}}>Selected: <b>Moderate</b></p>
                        <p className="fw-bold mb-3">Portfolio Breakdown</p>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Large Cap Stock Index</p>
                            <div className="d-flex align-items-center" style={{gap:'5px'}}>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{enrollment?.stocks}%</p>
                                <p className="mb-0 rounded-pill bg-prime px-2 py-0 fw-semibold" style={{fontSize:'12px'}}>moderate</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Bond Index Fund</p>
                            <div className="d-flex align-items-center" style={{gap:'5px'}}>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{enrollment?.bonds}%</p>
                                <p className="mb-0 rounded-pill bg-prime px-2 py-0 fw-semibold" style={{fontSize:'12px'}}>moderate</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Stable Value Fund</p>
                            <div className="d-flex align-items-center" style={{gap:'5px'}}>
                                <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>{enrollment?.cash}%</p>
                                <p className="mb-0 rounded-pill bg-success px-2 py-0 fw-semibold" style={{fontSize:'12px'}}>low</p>
                            </div>
                        </div>
                        <div className="py-2 rounded-3 text-center fe-semibold" style={{border:'2px solid #ff6b35',cursor:'pointer'}}>Get Risk-Based Recommendations</div>
                    </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Contribution